<template>
    <v-container>
        <v-row>
            <v-col cols='12'>
                <h3 class='d-block font-weight-bold flex-grow-1 mb-4 mt-3'>
                    <span v-if="$route.query.Status === 'OK'">پرداخت موفق</span>
                    <span v-else>پرداخت ناموفق</span>
                </h3>
                <v-col cols='12'>
                    <v-card v-if='loading' elevation='0'>
                        <v-card-title class='body-1'></v-card-title>
                        <v-card-text class='text-center'>
                            <v-progress-circular
                                    :size='50'
                                    indeterminate
                                    color='primary'
                            ></v-progress-circular>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'CompletePayment',
        data() {
            return {
                loading: false,
                errorDialog: false,
                err: {
                    statusCode: null
                },
                invoice: {
                    unit: {}
                }
            };
        },
        methods: {
            async checkPayment() {
                this.loading = true;
                await axios
                    .post(`/api/invoices/${this.invoice_id}/verify`, {
                        authority: this.$route.query.Authority
                    })
                    .then(res => {
                        this.invoice = res.data.invoice;
                        setTimeout(() => {
                            this.loading = false;
                            this.$router.push({name: 'Invoice'});
                        }, 3000);
                    })
                    .catch(err => {
                        setTimeout(() => {
                            this.loading = false;
                            this.$router.push({name: 'Invoice'});
                        }, 3000);
                        this.err.statusCode = err.response.status;
                        this.errorDialog = true;
                    });
            }
        },
        created: async function () {
            this.invoice_id = this.$route.params.invoice_id;
            await this.checkPayment();
        }
    };
</script>

<style lang='scss'>
    .complete-payment-card {
        .ref-id {
            font-size: 0.775rem !important;
        }
    }

    .check-payment-skeleton {
        .v-skeleton-loader__table-row {
            justify-content: space-evenly !important;
        }

        .v-skeleton-loader__table-cell {
            height: 32px;
        }
    }
</style>